import React from 'react'
import { Button, Link, Stack } from '@chakra-ui/core'
import { useAuthContext } from '../../../context/AuthProvider'
import { PRIVACY_POLICY_URL } from '../../../constants'

const SettingsContainer = () => {
  const { logout } = useAuthContext()

  return (
    <Stack spacing={4} mt={4}>
      <Link href={PRIVACY_POLICY_URL} isExternal>
        <Button fontSize="xs" variant="ghost" mt={4}>
          Privacy Policy
        </Button>
      </Link>
      <Button
        variantColor="red"
        fontSize="xs"
        variant="solid"
        onClick={() => logout?.()}
        mt={4}
        w="7rem"
      >
        Logout
      </Button>
    </Stack>
  )
}

export default SettingsContainer
